import { BACKEND_CONSTANTS } from './constants'
import { post, get, destroy } from './helpers'

const authenticateUser = async credentials =>
  post('authenticate', BACKEND_CONSTANTS.AUTHENTICATE.AUTHENTICATE_USER, credentials)
const checkAuthenticated = async () => get('authenticate', BACKEND_CONSTANTS.AUTHENTICATE.CHECK_AUTHENTICATED)
const logout = async () => destroy('authenticate', BACKEND_CONSTANTS.AUTHENTICATE.LOGOUT)

export { authenticateUser, checkAuthenticated, logout }
